// @deprecated TODO(settings-v2-cleanup)
// Last V1 redux-connect class component still routed at /solar.  Once
// V2 site settings ships a SolarOptionsSection with confirmed feature
// parity, drop this page + its route.  Search for
// ``settings-v2-cleanup`` to find every remaining V1 surface.

import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Formsy from 'formsy-react';
import moment from 'moment';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import DateBox from '@sophocles/components/FormFields/DateBox';
import SelectBox from '@sophocles/components/FormFields/SelectBox';
import TextBox from '@sophocles/components/FormFields/TextBox';
import LoadingScreen from '@sophocles/components/LoadingScreen';
import {
  createSolarSiteOption,
  fetchSolarSiteOptionForSite,
  getSolarSiteOptionForSelectedSite,
  patchSolarSiteOption,
} from '@sophocles/entities/SolarSiteOption';
import { useSiteDashboardLayoutContext } from '@sophocles/views/sites/SiteDashboardLayout';

const subHeaderStyle = { padding: '16px 0 0', color: '#444' };

const style = {
  outerStyle: { display: 'flex', alignItems: 'center', margin: '5px' },
  labelStyle: {
    margin: '0 5px 0 0',
    flex: '50% 0 0',
    textAlign: 'right',
    fontWeight: '500',
  },
  inputStyle: { width: '300px' },
};

const dateConverter = (object, name) => {
  if (moment(object[name]).isValid()) {
    object[name] = moment(object[name]).format('yyyy-MM-dd');
  }
};

const nullConverter = (object, name) => {
  if (object[name] == '') {
    object[name] = null;
  }
};

class SolarOptionsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: true,
    };
  }

  componentDidMount() {
    const { fetchSolarSiteOptionsForSite, selectedStructure_id } = this.props;
    fetchSolarSiteOptionsForSite(selectedStructure_id);
  }

  submit = values => {
    const { selectedSolarSiteOption, selectedStructure_id, patchSolarSiteOption, createSolarSiteOption } = this.props;

    // date fields must be converted to yyyy-MM-dd to store
    dateConverter(values, 'date_electric_permit_granted');
    dateConverter(values, 'date_building_permit_granted');
    dateConverter(values, 'lighting_completion_date');
    dateConverter(values, 'mechanical_solar_completion_date');
    dateConverter(values, 'electrical_completion_date');
    dateConverter(values, 'interconnection_agreement_filed');
    dateConverter(values, 'final_electrical_inspection_date');
    dateConverter(values, 'interconnection_agreement_approved');
    dateConverter(values, 'in_service_date');

    // Integer fields must be nulled out if they were left blank
    nullConverter(values, 'number_of_faces');
    nullConverter(values, 'solar_generator_voltage');
    nullConverter(values, 'solar_panel_tilt');
    nullConverter(values, 'panels_per_array');
    nullConverter(values, 'lighting_design_wattage');
    nullConverter(values, 'solar_panel_wattage');
    nullConverter(values, 'system_voltage');
    nullConverter(values, 'number_of_arrays_installed');
    nullConverter(values, 'number_of_relays_in_controller');
    nullConverter(values, 'quantity_of_inverters_installed');
    nullConverter(values, 'total_number_lights_installed');
    nullConverter(values, 'total_system_wattage');

    // Reverse these two if they are null
    if (values.date_electric_permit_granted == null) {
      values.date_electric_permit_granted = '';
    }
    if (values.date_building_permit_granted == null) {
      values.date_building_permit_granted = '';
    }

    if (selectedSolarSiteOption != null) {
      const id = selectedSolarSiteOption.get('id', 0);
      patchSolarSiteOption(id, values);
    } else {
      const site_id = selectedStructure_id;
      values.site = site_id;
      createSolarSiteOption(values);
    }
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  onSubmit = () => {
    this.myRef.submit();
  };

  render() {
    const { selectedSolarSiteOption, selectedStructure, t } = this.props;
    const { options, canSubmit } = this.state;

    return (
      <div className="row">
        <div className="col-md-12">
          <Paper
            style={{
              width: '100%',
              backgroundColor: 'var(--surface-primary)',
              padding: '16px 16px',
              marginBottom: '16px',
            }}
          >
            <Formsy
              ref={input => (this.myRef = input)}
              onSubmit={this.submit}
              onValid={this.enableButton}
              onInvalid={this.disableButton}
              className=""
            >
              <h3 style={subHeaderStyle}>Structure Info</h3>
              <div className="row">
                <div className="col-lg-6">
                  <div>Structure Name: {selectedStructure.get('name', '')}</div>
                  <div>Description: {selectedStructure.get('description', '')} </div>
                  <div>Address: {selectedStructure.get('location_description', '')}</div>
                  <div>Latitude: {selectedStructure.get('latitude', '')} </div>
                  <div>Longitude: {selectedStructure.get('longitude', '')}</div>
                </div>
                <div className="col-lg-6">
                  <div>
                    <SelectBox
                      name="solar_active"
                      title={t('solar.activeSolarStructure')}
                      value={selectedSolarSiteOption ? selectedSolarSiteOption.get('solar_active', false) : true}
                      style={{ width: '350px' }}
                    >
                      <MenuItem value={false}>No</MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                    </SelectBox>
                  </div>
                  <div>
                    <SelectBox
                      name="exclude_from_solar_report"
                      title={t('solar.excludeFromReport')}
                      value={
                        selectedSolarSiteOption
                          ? selectedSolarSiteOption.get('exclude_from_solar_report', false)
                          : false
                      }
                      style={{ width: '350px' }}
                    >
                      <MenuItem value={false}>No</MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                    </SelectBox>
                  </div>
                </div>
              </div>

              <h3 style={subHeaderStyle}>Basic Options</h3>
              <div className="row">
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="nominal_size"
                    title={t('solar.nominalSize')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="number_of_faces"
                    title={t('solar.numberOfFaces')}
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_generator_voltage"
                    title={t('solar.solarMeterVoltage')}
                    validations="maxLength:5"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <SelectBox
                    name="obstructions_to_solar"
                    title={t('solar.anyObstructions')}
                    value={
                      selectedSolarSiteOption ? selectedSolarSiteOption.get('obstructions_to_solar', false) : false
                    }
                    style={{ width: '350px' }}
                  >
                    <MenuItem value={false} primaryText="No" />
                    <MenuItem value={true} primaryText="Yes" />
                  </SelectBox>
                </div>
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="configuration"
                    title={t('solar.configuration')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_orientation"
                    title={t('solar.orientation')}
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_panel_tilt"
                    title={t('solar.solarPanelTilt')}
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <SelectBox
                    name="tree_trimming_required"
                    title={t('solar.treeTrimmingRequired')}
                    value={
                      selectedSolarSiteOption ? selectedSolarSiteOption.get('tree_trimming_required', false) : false
                    }
                    style={{ width: '350px' }}
                  >
                    <MenuItem value={false}>No</MenuItem>
                    <MenuItem value={true}>Yes</MenuItem>
                  </SelectBox>
                </div>
              </div>

              <h3 style={subHeaderStyle}>Installed Components</h3>
              <div className="row">
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_panel_manufacturer"
                    title={t('solar.solarPanelManufacturer')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_array_serial"
                    title={t('solar.solarPanelArraySerial')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="panels_per_array"
                    title={t('solar.panelsPerArray')}
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="total_system_wattage"
                    title={t('solar.totalInstalledWattage')}
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="inverter_manufacturer"
                    title={t('solar.inverterManufacturer')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="inverter_serial_number"
                    title={t('solar.inverterSerialNumbers')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="inverter_serial_number_3"
                    title={t('solar.inverterSerialNumbers')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="inverter_serial_number_5"
                    title={t('solar.inverterSerialNumbers')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_manufacturer"
                    title={t('solar.lightingManufacturer')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="total_number_lights_installed"
                    title={t('solar.totalLightsInstalled')}
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_design_wattage"
                    title={t('solar.designWattage')}
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_controller_model_number"
                    title={t('solar.lightingControllerModel')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="number_of_relays_in_controller"
                    title={t('solar.numberOfRelays')}
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                </div>
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_panel_model_number"
                    title={t('solar.solarPanelModelNumber')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_panel_wattage"
                    title="Solar Panel Wattage"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="number_of_arrays_installed"
                    title="Number of Arrays Installed"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="quantity_of_inverters_installed"
                    title="Quantity of Inverters Installed"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="inverter_model_number"
                    title="Inverter Model Number"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="inverter_serial_number_2"
                    title={t('solar.inverterSerialNumbers')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="inverter_serial_number_4"
                    title={t('solar.inverterSerialNumbers')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="inverter_serial_number_6"
                    title={t('solar.inverterSerialNumbers')}
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_model_number"
                    title="Lighting Model Number"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="individual_light_serial_numbers"
                    title="Individual Light Serial Number(s)"
                    validations="maxLength:40"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_controller_manufacturer"
                    title="Lighting Controller Manufacturer"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_controller_serial_number"
                    title="Lighting Controller Serial Number"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                </div>
              </div>

              <h3 style={subHeaderStyle}>Utility & Permitting Information</h3>
              <div className="row">
                <div className="col-lg-6">
                  {/* <TextBoxCreator record={selectedSolarSiteOption} name="FAKE NAME" title="Electirc Utility" validations="maxLength:20" validationError='Too Long' style={{width:'350px'}} /> */}
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="meter_number"
                    title="Meter Number"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="system_voltage"
                    title="System Voltage"
                    validations="maxLength:5"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                    type="number"
                  />
                  <SelectBox
                    name="system_phasing"
                    title="System Phasing"
                    value={selectedSolarSiteOption ? selectedSolarSiteOption.get('system_phasing', null) : null}
                    style={{ width: '350px' }}
                  >
                    <MenuItem value={null}> </MenuItem>
                    <MenuItem value={1}>Single</MenuItem>
                    <MenuItem value={2}>Dual</MenuItem>
                    <MenuItem value={3}>Three</MenuItem>
                  </SelectBox>
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="utility_electrical_permit_number"
                    title="Electrical Permit Number"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                </div>
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="utility_state"
                    title="State"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="utility_city"
                    title="City or Town"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="utility_county"
                    title="County or Parish"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="utility_building_permit_number"
                    title="Building Permit Number"
                    validations="maxLength:20"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                </div>
              </div>

              <h3 style={subHeaderStyle}>Contractor Information</h3>
              <div className="row">
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="array_assembled_by"
                    title="Array Assembled By"
                    validations="maxLength:40"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_installed_by"
                    title="Lighting Installed By"
                    validations="maxLength:40"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                </div>
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_installed_by"
                    title="Solar/Mechanical Installed By"
                    validations="maxLength:40"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="electrical_solar_pv_installed_by"
                    title="Electrical/Solar PV Installed By"
                    validations="maxLength:40"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                </div>
              </div>

              <h3 style={subHeaderStyle}>Milestone Dates</h3>
              <div className="row">
                <div className="col-lg-6">
                  <DateBoxCreator
                    record={selectedSolarSiteOption}
                    name="date_electric_permit_granted"
                    title="Date Electrical Permit Granted"
                    textFieldStyle={{ width: '350px' }}
                  />
                  <DateBoxCreator
                    record={selectedSolarSiteOption}
                    name="date_building_permit_granted"
                    title="Date Building Permit Granted"
                    textFieldStyle={{ width: '350px' }}
                  />
                  <DateBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_completion_date"
                    title="Lighting Completion Date"
                    textFieldStyle={{ width: '350px' }}
                  />
                  <DateBoxCreator
                    record={selectedSolarSiteOption}
                    name="mechanical_solar_completion_date"
                    title="Mechanical/Solar Completion Date"
                    textFieldStyle={{ width: '350px' }}
                  />
                  <DateBoxCreator
                    record={selectedSolarSiteOption}
                    name="electrical_completion_date"
                    title="Electrical Controller Completion Date"
                    textFieldStyle={{ width: '350px' }}
                  />
                </div>
                <div className="col-lg-6">
                  <DateBoxCreator
                    record={selectedSolarSiteOption}
                    name="interconnection_agreement_field"
                    title="Interconnection Agreement Filed"
                    textFieldStyle={{ width: '350px' }}
                  />
                  <DateBoxCreator
                    record={selectedSolarSiteOption}
                    name="final_electrical_inspection_date"
                    title="Date of Final Electrical Inspection"
                    textFieldStyle={{ width: '350px' }}
                  />
                  <DateBoxCreator
                    record={selectedSolarSiteOption}
                    name="interconnection_agreement_approved"
                    title="Interconnection Agreement Approved"
                    textFieldStyle={{ width: '350px' }}
                  />
                  <DateBoxCreator
                    record={selectedSolarSiteOption}
                    name="in_service_date"
                    title="In-service Date (date of first grid-tie)"
                    textFieldStyle={{ width: '350px' }}
                  />
                </div>
              </div>

              <h3 style={subHeaderStyle}>Proof Of Performance</h3>
              <div className="row">
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_photo_number"
                    title="Photo Number - Lighting only"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="completed_install_photo_number"
                    title="Photo Number - Completed install"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                </div>
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="design_power_consumption"
                    title="Design Power Consumption, kWh per month"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="design_power_generation"
                    title="Design Power Generation, kWh per month"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                </div>
              </div>

              <h3 style={subHeaderStyle}>Costs</h3>
              <div className="row">
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="array_assembly_labor"
                    title="Labor - Array Assembly"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_install_cost"
                    title="Solar Install"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_electrical_cost"
                    title="Solar PV System - Electrical Equipment"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_cost"
                    title="Lighting (including light arm and jb)"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_controller_cost"
                    title="Lighting Controller"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                </div>
                <div className="col-lg-6">
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_install_cost"
                    title="Lighting Install"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="lighting_controller_install_cost"
                    title="Lighting Controller and Electrical Install"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="solar_mechanical_cost"
                    title="Solar PV System - Mechanical Equipment"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                  <TextBoxCreator
                    record={selectedSolarSiteOption}
                    name="additional_permitting_expense"
                    title="Additional Permitting Expense"
                    validations="maxLength:10"
                    validationError="Too Long"
                    style={{ width: '350px' }}
                  />
                </div>
              </div>
            </Formsy>
          </Paper>

          <div style={{ display: 'flex', flexDirection: 'row-reverse', marginBottom: '16px' }}>
            <Button variant="contained" color="primary" onClick={this.onSubmit} disabled={!canSubmit}>
              {t('actions.saveOptions')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedSolarSiteOption: getSolarSiteOptionForSelectedSite(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSolarSiteOptionsForSite: site => dispatch(fetchSolarSiteOptionForSite(site)),
    patchSolarSiteOption: (id, values) => dispatch(patchSolarSiteOption(id, values)),
    createSolarSiteOption: values => dispatch(createSolarSiteOption(values)),
  };
}

const ConnectedSolarOptionsPage = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SolarOptionsPage));

function SolarOptionsPageContainer(props) {
  const { selectedStructure, siteId, loading } = useSiteDashboardLayoutContext();
  if (loading) {
    return <LoadingScreen />;
  }
  return <ConnectedSolarOptionsPage {...props} selectedStructure={selectedStructure} selectedStructure_id={siteId} />;
}

export default SolarOptionsPageContainer;

class TextBoxCreator extends React.Component {
  render() {
    const { name, record } = this.props;

    let value = record == null ? '' : record.get(name, '') + '';

    if (value == 'null') {
      value = ''; // If JS cannot figure out the date, then it is no date of mine.
    }

    return <TextBox {...this.props} value={value} />;
  }
}

class DateBoxCreator extends React.Component {
  render() {
    const { name, record } = this.props;

    let value = record ? new Date(record.get(name, null) + '') : null;

    if (value == 'Invalid Date') {
      value = null; // If JS cannot figure out the date, then it is no date of mine.
    }
    return <DateBox {...this.props} value={value} />;
  }
}
